import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import "../css/modalAppointmentByAgenda.css";
import { format } from "date-fns";
import { it } from "date-fns/locale";

interface AppointmentModalProps {
  open: boolean;
  onClose: () => void;
  appointmentData: {
    descEsame: string;
    tipoAgenda: string;
    nomeMedico: string;
    dataEsame: string;
    oraEsame: string;
    durataEsame: string;
    codicePrenotazione: string;
    dataPrenotazione: string;
    noteEsame: string;
    nomePaziente: string;
    aziendaPrenotazione: string;
    cognomePaziente: string;
  };
}

const ModalAppointmentByAgenda: React.FC<AppointmentModalProps> = ({
  open,
  onClose,
  appointmentData,
}) => {
  const formatHour = (time: any) => {
    if (!time || typeof time !== "string") {
      return ""; // Restituisce un valore di fallback se il tempo è indefinito o non è un numero
    }

    // Converte il numero in una stringa con zeri iniziali (se necessario)
    const timeString = time.toString().padStart(4, "0");

    // Prende le prime due cifre come ore e le ultime due come minuti
    const hours = timeString.substring(0, 2);
    const minutes = timeString.substring(2);

    // Restituisce l'orario formattato come HH:mm
    return `${hours}:${minutes}`;
  };

  const formatDate = (dateString: string) => {
    const parsedDate = new Date(dateString);
    if (!isNaN(parsedDate.getTime())) {
      return format(parsedDate, "dd/MM/yyyy", { locale: it });
    }
    return dateString; // Restituisce il valore originale se non è una data valida
  };

  console.log({ appointmentData });

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-title">
      <Box className="modal-container">
        <Box className="modal-content">
          <Typography
            id="modal-title"
            variant="h6"
            className="modal-title appointmentDescr"
            sx={{ fontWeight: "bold" }}
          >
            {appointmentData.descEsame}
          </Typography>

          {/* Sezione informazioni esame */}
          <Box className="info-section">
            <Typography
              variant="subtitle1"
              className="info-section-title appointmentDescr"
              sx={{ fontWeight: "bold" }}
            >
              {appointmentData.tipoAgenda}
            </Typography>
            <Typography variant="body2" className="appointmentDescr">
              <span style={{ fontWeight: "bold" }}>Nome Medico: </span>
              {appointmentData.nomeMedico}
            </Typography>
            <Typography variant="body2" className="appointmentDescr">
              <span style={{ fontWeight: "bold" }}>Nominativo Paziente: </span>
              {appointmentData.cognomePaziente} {appointmentData.nomePaziente}
            </Typography>
            <Typography variant="body2" className="appointmentDescr">
              <span style={{ fontWeight: "bold" }}>Data Esame: </span>
              {formatDate(appointmentData.dataEsame)}
            </Typography>
            <Typography variant="body2" className="appointmentDescr">
              <span style={{ fontWeight: "bold" }}>Ora Esame: </span>
              {formatHour(appointmentData.oraEsame)}
            </Typography>
            <Typography variant="body2" className="appointmentDescr">
              <span style={{ fontWeight: "bold" }}>Durata Esame: </span>
              {appointmentData.durataEsame} minuti
            </Typography>
            <Typography variant="body2" className="appointmentDescr">
              <span style={{ fontWeight: "bold" }}>Prenotazione: </span>
              {appointmentData.codicePrenotazione}
            </Typography>
            <Typography variant="body2" className="appointmentDescr">
              <span style={{ fontWeight: "bold" }}>Azienda: </span>
              {appointmentData.aziendaPrenotazione}
            </Typography>
            <Typography variant="body2" className="appointmentDescr">
              <span style={{ fontWeight: "bold" }}>Data Prenotazione: </span>
              {formatDate(appointmentData.dataPrenotazione)}
            </Typography>
          </Box>

          {/* Sezione Note */}
          <Box className="notes-section">
            <Typography
              variant="subtitle1"
              className="info-section-title"
              marginBottom={"10px"}
            >
              Note Esame
            </Typography>
            <Typography variant="body2" className="notes-content">
              {appointmentData.noteEsame || "Nessuna nota disponibile"}
            </Typography>
          </Box>

          <Button
            variant="outlinedError"
            onClick={onClose}
            className="modal-close-button"
          >
            Chiudi
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalAppointmentByAgenda;
